function FocusTrap($container, $trigger) {
    if (!$container) {
        throw new Error('FocusTrap requires an element to be passed to it.');
    }

    this.$container = $container;
    this.$activeElement = $trigger;
    this.lastFocus = null;
    this.focusableElements = findFocusable($container);
    this.handleFocus = this.handleFocus.bind(this);
}

FocusTrap.prototype.handleFocus = function(e) {
    if (this.$container.contains(e.target)) {
        this.lastFocus = e.target;
    } else {
        if (this.lastFocus === this.focusableElements[0]) {
            this.focusableElements[this.focusableElements.length - 1].focus();
        } else {
            this.focusableElements[0].focus();
        }

        this.lastFocus = document.activeElement;
    }
};

FocusTrap.prototype.enable = function() {
    if (this.focusableElements.length) {
        document.addEventListener('focus', this.handleFocus, true);
        this.focusableElements[0].focus();
    }
};

FocusTrap.prototype.disable = function() {
    if (this.focusableElements.length) {
        document.removeEventListener('focus', this.handleFocus, true);
        this.lastFocus = null;

        if (this.$activeElement && this.$activeElement.tagName !== 'BODY') {
            this.$activeElement.focus();
        }
    }
};

function findFocusable(element) {
    return Array.from(element.querySelectorAll('[tabindex], button, a, input, textarea, select')).filter(function(e) {
        return !e.disabled;
    });
}

export default FocusTrap;
